var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "meta"
  }, [_vm.asset.alias ? _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Alias "), _c('TooltipMeta', {
    attrs: {
      "content": 'Alias of ' + _vm.asset.id
    }
  })], 1), _c('p', {
    staticClass: "meta_value"
  }, [_vm._v(" " + _vm._s(_vm.asset.alias) + " ")])]) : _vm._e(), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" ID "), _c('TooltipMeta', {
    attrs: {
      "content": 'Unique identifier of token'
    }
  })], 1), _c('p', {
    staticClass: "meta_value"
  }, [_c('router-link', {
    attrs: {
      "to": "/tx/".concat(_vm.asset.id)
    }
  }, [_vm._v(_vm._s(_vm.asset.id))])], 1)]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Asset Type "), _c('TooltipMeta', {
    attrs: {
      "content": "The type of asset (NFT, variable or fixed cap)"
    }
  })], 1), _c('p', {
    staticClass: "meta_value"
  }, [_vm._v(_vm._s(_vm._f("getAssetType")(_vm.asset)))])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Created "), _c('TooltipMeta', {
    attrs: {
      "content": 'When and where ' + _vm.asset.symbol + ' was minted'
    }
  })], 1), _c('p', {
    staticClass: "meta_value"
  }, [_c('fa', {
    staticClass: "time_icon",
    attrs: {
      "icon": ['far', 'clock']
    }
  }), _vm._v(" " + _vm._s(_vm._f("fromNow")(_vm.date)) + " (" + _vm._s(_vm.date.toLocaleString()) + ") on "), _c('span', {
    staticClass: "chain_tag",
    style: {
      backgroundColor: _vm.background
    }
  }, [_vm._v(_vm._s(_vm._f("blockchain")(_vm.asset.chainID)))])], 1)]), !_vm.isNFT ? _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Unit "), _c('TooltipMeta', {
    attrs: {
      "content": 'minimal transferable unit of this asset'
    }
  })], 1), _c('p', {
    staticClass: "meta_value"
  }, [_vm._v(" " + _vm._s(_vm.minimalTransferrableUnit) + " (" + _vm._s(_vm._f("pluralizeDenomination")(_vm.asset.denomination)) + ") ")])]) : _vm._e(), !_vm.isNFT ? _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Initial Supply "), _c('TooltipMeta', {
    attrs: {
      "content": 'Type of asset'
    }
  })], 1), _c('p', {
    staticClass: "meta_value"
  }, [_vm._v(" " + _vm._s(_vm.asset.currentSupply.toLocaleString(_vm.asset.denomination)) + " "), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.asset.symbol))])])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }